// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-budget {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.file-budget .pagination {
  justify-content: flex-end;
}
.file-budget .icon-button-file {
  padding-right: 7px;
  position: relative;
  top: -2px;
}
.file-budget .icon-button-file.file-delete {
  left: 15px;
}
.file-budget .icon-button-file.file-download {
  left: 20px;
}
.file-budget .nameFile {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.file-budget .nameFile h6 {
  margin-bottom: 0;
  font-weight: bold;
  word-break: break-all;
}
.file-budget .nameFile span {
  color: #ADADAD;
}
.file-budget .buttonFile {
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
}
@media (min-width: 565px) {
.file-budget .buttonFile a {
    padding-right: 15px;
}
}
.file-budget .circle {
  background-color: #eaeaea;
  padding: 15px;
  border-radius: 70px;
  width: 57px;
  color: #007bff;
  margin-top: 7px;
  margin-bottom: 7px;
}
.file-budget .circle span {
  justify-content: center;
  display: flex;
}
.file-budget .addFiles {
  position: absolute;
  right: 0px;
  top: 1px;
  color: #0078dc;
  width: 109px;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.file-budget .card-header label .fa-icon {
  position: relative;
  top: -1px;
  left: -4px;
  pointer-events: all;
}
.file-budget button:focus {
  box-shadow: none;
}
.file-budget h5 button {
  width: 100%;
  text-align: left;
  font-size: 1.44rem;
}
.file-budget .active {
  color: #0078dc;
}
.file-budget .number {
  padding: 0 5px;
  font-weight: bold;
  cursor: pointer;
}
.file-budget .arrow {
  cursor: pointer;
  position: relative;
  top: -1.76px;
}
.file-budget .card-body {
  padding: 35px 15px;
  padding-bottom: 10px;
  padding-top: 0;
}
.file-budget .card-body .row:nth-child(even) {
  background-color: #f9f9f9;
}
.file-budget .card-body .btn-primary {
  background-color: transparent;
  border: 1px solid #ADADAD;
  box-shadow: none !important;
  color: #007bff;
  margin-right: 5px;
}
.file-budget .card-body .btn {
  color: #007bff;
}
@media (max-width: 575px) {
.file-budget .file-action {
    display: none;
}
.file-budget .icon-button-file.file-delete {
    left: 0;
}
.file-budget .icon-button-file.file-download {
    left: 0;
}
.file-budget .circle {
    margin-left: 5px;
}
.file-budget .nameFile h6 {
    font-size: 1.44rem;
}
.file-budget .nameFile span {
    font-size: 15px;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
